import { complex, rwAttrib, complexAttrib } from '../schema-engine';
import { getCMIString4000, setCMIString4000, getCMIString250, setCMIString250 } from './cmi-string.actions';
import { getCompletionStatus, setCompletionStatus } from './completion-status.actions';
import { getSuccessStatus, setSuccessStatus } from './success-status.actions';
import { score } from './score-schema';
import { getOptionalReal, setOptionalRealRange } from './real.actions';

export function objective() {
  return complex({
    id: rwAttrib(getCMIString4000, setCMIString4000, 'id'),
    score: complexAttrib(score(), 'score'),
    completion_status: rwAttrib(getCompletionStatus, setCompletionStatus, 'completionStatus'),
    success_status: rwAttrib(getSuccessStatus, setSuccessStatus, 'successStatus'),
    progress_measure: rwAttrib(getOptionalReal, setOptionalRealRange(0, 1), 'progressMeasure'),
    description: rwAttrib(getCMIString250, setCMIString250, 'description')
  });
}
